(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define("@homeaway/stab-message-reader", ["exports"], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.homeawayStabMessageReader = mod.exports;
    }
})(this, function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    /**
     * `MessageReader` provides an interface for reading messages
     * compiled with `grunt-messageformat`. For example:
     *
     * In messages-en_US_VRBO.js:
     *   MessageReader.registerMessages({...}, 'stabHit', 'en_US_VRBO');
     *
     * In your app:
     *   MessageReader.read('shared.stab.hit.book');
     */

    var messageCache = {};
    var loggingEnabled = true;
    var currentLocale = void 0;
    var currentCategory = void 0;

    /**
     * Output a message in the console using `console.error`.
     * @private
     * @param  {String} locale   Ex: en_US_HA
     * @param  {String} category Ex: stabHit
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @param  {Object} options  Ex: {REVIEWS: 5}
     */
    function logError(error) {
        if (!loggingEnabled) {
            return;
        }

        var message = error.message + "\nMessage Cache: %o";

        console.error(message, messageCache); // eslint-disable-line no-console
    }

    /**
     * Traverse the message cache to retrieve a message.
     * @private
     * @param  {String} locale   Ex: en_US_HA
     * @param  {String} category Ex: stabHit
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @return {String|Boolean}
     */
    function getMessage(locale, category, key) {
        var message = messageCache[locale];

        if (message) {
            message = message[category];

            if (message) {
                message = message[key];

                if (message) {
                    return message;
                }

                throw new Error("Key \"" + key + "\" was not found in \"" + locale + "." + category + "\".");
            } else {
                throw new Error("Could not lookup \"" + key + "\" because category \"" + category + "\" was not found in locale \"" + locale + "\".");
            }
        } else {
            throw new Error("Could not lookup \"" + key + "\" because locale \"" + locale + "\" was not found.");
        }
    }

    /**
     * Enable error logging
     * @public
     * @param  {Boolean} isEnabled True to enable logging; False to disable logging;
     */
    function enableLogging() {
        var isEnabled = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        loggingEnabled = isEnabled;
    }

    /**
     * Register a set of translations with the Message Reader
     *
     * Ex:
     * `translations`
     * {
     *     "search.app.button.hide.regions": "Hide regions",
     *     "search.app.button.view.region": "View Regions",
     *     "search.app.button.view.regions": "View regions",
     *     "search.app.tabs.filter": "Filter",
     *     "search.app.tabs.list": "List",
     *     "search.app.tabs.map": "Map"
     * }
     *
     * @public
     * @param  {Object} translations An object representing a set of translations
     * @param  {String} category     Ex: stabHit
     * @param  {String} locale       Ex: en_US_HA
     */
    function registerMessages(translations, category, locale) {
        if (!messageCache[locale]) {
            messageCache[locale] = {};
        }

        messageCache[locale][category] = translations;
    }

    /**
     * Specify a default locale to use when reading messages without specifying a locale;
     * @public
     * @param {String} locale Ex: en_US_HA
     */
    function setLocale(locale) {
        currentLocale = locale;
    }

    /**
     * Specify a default locale to use when reading messages without specifying a locale;
     * @public
     * @param {String} category Ex: stabHit
     */
    function setCategory(category) {
        currentCategory = category;
    }

    /**
     * Read a message by passing a key and replacement value
     * @public
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @param  {Object} options  Ex: {REVIEWS: 5}
     * @param  {String} category Defaults to default category. Ex: stabHit
     * @param  {String} locale   Defaults to default locale. Ex: en_US_HA
     * @return {String}
     */
    function read(key, options) {
        var category = arguments.length <= 2 || arguments[2] === undefined ? currentCategory : arguments[2];
        var locale = arguments.length <= 3 || arguments[3] === undefined ? currentLocale : arguments[3];

        var message = void 0;

        try {
            message = getMessage(locale, category, key);
        } catch (error) {
            logError(error);
        }

        if (message) {
            return message(options);
        }

        return "???" + key + "???";
    }

    /**
     * Check whether a message exists given it's key.
     * @public
     * @param  {String} key      Ex: shared.stab.hit.submit
     * @param  {String} category Defaults to default category. Ex: stabHit
     * @param  {String} locale   Defaults to default locale. Ex: en_US_HA
     * @return {Boolean}
     */
    function exists(key) {
        var category = arguments.length <= 1 || arguments[1] === undefined ? currentCategory : arguments[1];
        var locale = arguments.length <= 2 || arguments[2] === undefined ? currentLocale : arguments[2];

        var message = void 0;

        try {
            message = getMessage(locale, category, key);
        } catch (error) {
            return false;
        }

        return !!message;
    }

    exports.enableLogging = enableLogging;
    exports.registerMessages = registerMessages;
    exports.setLocale = setLocale;
    exports.setCategory = setCategory;
    exports.read = read;
    exports.exists = exists;
});
//# sourceMappingURL=main.js.map
;
